/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService
 */

export const AchDetailsTypename = 'com.hubspot.paymentsexternalobjects.models.paymentmethod.details.AchDetails';
export const BacsDetailsTypename = 'com.hubspot.paymentsexternalobjects.models.paymentmethod.details.BacsDetails';
export const CardDetailsTypename = 'com.hubspot.paymentsexternalobjects.models.paymentmethod.details.CardDetails';
export const PadsDetailsTypename = 'com.hubspot.paymentsexternalobjects.models.paymentmethod.details.PadsDetails';
export const SepaDetailsTypename = 'com.hubspot.paymentsexternalobjects.models.paymentmethod.details.SepaDetails';
export const getActivePaymentMethodOnFileListForContactRpc = {
  serviceName: 'com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService',
  rpcName: 'getActivePaymentMethodOnFileListForContact',
  auth: 'app',
  fingerprint: '0s151hVkmorPsRh7zulkhA0XcZFz_8jN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};